export const HIDE_COLUMNS = [
	'viewAdded',
	'itemType',
	'status',
	'salesOrderNumber',
	'icbIndicator',
	'quantity',
	'uom',
	'localCurrency',
	'exchangeRate',
	'totalLocalCurrency',
	'specialPricingCondition',
	'payTermsRevenue',
	'profitCenterRevenue',
	'errorReason',
	'passThrough',
];

export const SHOW_COLUMNS = [
	'chargeItem',
	'materialDescription',
	'salesOrderNumber',
	'quantity',
	'uom',
	'rate',
	'condCurrency',
	'total',
	'vatPartner',
	'vatPartnerReasonCodeNo',
];

export const NO_REASON_MSG = 'Please select a reason for editing the VAT Partner.';